export const evalColors = {
    teacher: '#93c5fd', // light blue
    student: '#2563eb', // blue
    ground_truth: '#646464', // dark gray – reference baseline
};

// Score coloring thresholds (used in tables/charts)
// Easy to tweak in one place.
export const scoreColorBands = [
    { maxExclusive: 40, color: '#ef4444' }, // red
    { maxExclusive: 60, color: '#f97316' }, // orange
    { maxExclusive: 80, color: '#2563eb' }, // blue
    { maxExclusive: Infinity, color: '#52c41a' }, // green
];

export const normalizeToPercent = (value) => {
    if (value === null || value === undefined) return null;
    if (typeof value === 'string' && value.trim() === '') return null;
    const n = typeof value === 'number' ? value : Number(value);
    if (!Number.isFinite(n)) return null;
    // Many classic metrics are stored as 0..1; treat them as percentages for UI coloring.
    return n <= 1.5 ? n * 100 : n;
};

export const getScoreColor = (value) => {
    const pct = normalizeToPercent(value);
    if (pct === null) return '#6b7280';
    const band = scoreColorBands.find((b) => pct < b.maxExclusive) || scoreColorBands[scoreColorBands.length - 1];
    return band.color;
};

export class ScoreBadge {
    static Excellent = "Excellent";
    static Good = "Good";
    static Fair = "Fair";
    static Poor = "Poor";
    static NoData = "No data";

    static values() {
        return [ScoreBadge.Excellent, ScoreBadge.Good, ScoreBadge.Fair, ScoreBadge.Poor, ScoreBadge.NoData];
    }
}

export const getScoreLabel = (scorePercent) => {
    if (scorePercent === null || scorePercent === undefined || scorePercent === '') return ScoreBadge.NoData;
    if (scorePercent >= 90) return ScoreBadge.Excellent;
    if (scorePercent >= 75) return ScoreBadge.Good;
    if (scorePercent >= 50) return ScoreBadge.Fair;
    return ScoreBadge.Poor;
};

/** True when a generative sample has no stored teacher/student output. */
export const isMissingGenerativeOutput = (value) => {
    if (value == null) return true;
    if (typeof value === 'string') return value.trim() === '';
    return false;
};

export const formatScoreDisplay = (score) => {
    const pct = normalizeToPercent(score);
    if (pct === null || !Number.isFinite(Number(pct))) return null;
    return (Math.round(Number(pct) * 100) / 100)
        .toFixed(2)
        .replace(/\.00$/, '')
        .replace(/(\.\d)0$/, '$1');
};

export const LegendItem = ({ color, label }) => {
    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span
                style={{
                    width: 32,
                    height: 12,
                    borderRadius: 999,
                    background: color,
                    display: 'inline-block',
                }}
            />
            <div style={{ color: '#4A5565', fontSize: 14, fontWeight: 400 }}>{label}</div>
        </div>
    );
};